import autoBind      from 'react-autobind';
import React         from 'react';
import { PropTypes } from 'prop-types';

import Select from '~/components/forms/select';

class TaskCategorySelect extends React.Component {
  constructor(props) {
    super(props);

    const options = [
      { label: 'Follow Up',    value: 'follow_up' },
      { label: 'Call',         value: 'call' },
      { label: 'Email',        value: 'email' },
      { label: 'SMS Text',     value: 'sms_text' },
      { label: 'Appointment',  value: 'appointment' },
      { label: 'Letter',       value: 'letter' },
      { label: 'Social Media', value: 'social_media' },
      { label: 'Other',        value: 'other' },
    ];

    this.state = {
      options,
    };

    autoBind(this);
  }

  render() {
    const { options } = this.state;
    const { value, onChange } = this.props;

    return (
      <Select
        {...this.props}
        value={value}
        onChange={onChange}
        options={options}
      />
    );
  }
}

TaskCategorySelect.defaultProps = {
  onChange:    () => {},
  value:       '',
};

TaskCategorySelect.propTypes = {
  onChange:    PropTypes.func,
  value:       PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
};

export default TaskCategorySelect;
